<template>
    <div v-if="hasSocialtoolsPagesInfo" class="socialtools-page-info-details">
        <b-table :data="socialtoolsPages">
            <template slot-scope="props">
                <b-table-column field="socialNetwork" label="Network">
                    {{ props.row.socialNetwork }}
                </b-table-column>
                <b-table-column field="id" label="ID">
                    {{ props.row.id }}
                </b-table-column>
                <b-table-column field="name" label="Name">
                    <a :href="utilities.getSTPageLink(props.row.socialNetwork, props.row.id)" target="_"  title="Link to SocialTool page">
                        {{ props.row.name }}
                    </a>
                </b-table-column>
                <b-table-column field="startDate" label="Start Date">
                    {{ props.row.startDate | formatDate }}
                </b-table-column>
                <b-table-column field="activeStatus" label="Status" centered>
                    <div v-if="props.row.activeStatus">
                        <b-icon v-if="props.row.isActive" type="is-success" pack="fas" size="is-small" :title="props.row.activeStatus" icon="check"></b-icon>
                        <b-icon v-if="!props.row.isActive" type="is-danger" pack="fas" size="is-small" :title="props.row.activeStatus" icon="times"></b-icon>
                        {{ props.row.activeStatus }}
                    </div>
                </b-table-column>
            </template>
        </b-table>
    </div>
</template>

<script>
import utilities from '@/services/utility-service.js';

export default {
    name: 'SocialtoolsPagesInfo',
    props: {
        projectColumn: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            utilities
        };
    },
    methods: {
        isSocialtoolsPageNotActive (pageInfo) {
            return pageInfo && !pageInfo.isActive;
        },
        isSocialtoolsPageHasName (pageInfo) {
            return pageInfo && pageInfo.name;
        }
    },
    computed: {
        socialtoolsPages () {
            return buildSocialtoolsPages(this.projectColumn);
        },
        hasSocialtoolsPagesInfo () {
            return this.projectColumn.fbPageInfo || this.projectColumn.twPageInfo || this.projectColumn.ytPageInfo || this.projectColumn.igPageInfo;
        }
    }
};

function buildSocialtoolsPages (projectColumn) {
    let list = [];
    if (projectColumn.fbPageInfo && projectColumn.fbPageInfo.id) {
        list.push(projectColumn.fbPageInfo);
    }
    if (projectColumn.twPageInfo && projectColumn.twPageInfo.id) {
        list.push(projectColumn.twPageInfo);
    }
    if (projectColumn.ytPageInfo && projectColumn.ytPageInfo.id) {
        list.push(projectColumn.ytPageInfo);
    }
    if (projectColumn.igPageInfo && projectColumn.igPageInfo.id) {
        list.push(projectColumn.igPageInfo);
    }
    return list;
}
</script>

<style lang="scss" scoped>
.socialtools-page-info-details{
    margin: 10px -13px;

    /deep/ .table{
        background-color: #efefef;
        tr{
            background-color: transparent !important;
        }
    }
}
</style>
